// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { System, System as This } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol } from "@lg/shared";

export class UserLanguage {
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "UserDefinedConfiguration" as const,
    });
    static readonly __type = 'System.UserLanguage';
    private static valuePromise?: Promise<UserLanguage.ValueType>;

    static get(): Promise<UserLanguage.ValueType> {
        if (!this.valuePromise) {
            this.valuePromise = ExecutionService.executeMethodAndReturnData<UserLanguage.ValueType>('UserDefinedConfiguration', 'System', 'UserLanguage', undefined, 'get', [])
        }

        return this.valuePromise
    }

    static async set(value: UserLanguage.ValueType): Promise<void> {
        this.valuePromise = Promise.resolve(value)
        await ExecutionService.executeMethodAndReturnData<UserLanguage.ValueType>('UserDefinedConfiguration', 'System', 'UserLanguage', undefined, 'set', [value])
    }
}

export namespace UserLanguage {
    export type ValueType = string
}
